module.exports = __webpack_public_path__ + "img/Weapon_89.f82a0cc1.png";